// extracted by mini-css-extract-plugin
export default {"root":"LanguageSwitcher_root__Tddaq","option":"LanguageSwitcher_option__oSeXp","active":"LanguageSwitcher_active__XXv+Z","divider":"LanguageSwitcher_divider__7jDA-"};